// Business search functionality
(function () {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

  const consumersData = JSON.parse(document.querySelector('#__cv_data').innerHTML);

  /**
   * Track event to Google Tag Manager
   * @param {string} eventName - Name of the event
   * @param {Object} eventParams - Event parameters
   */
  function trackEvent(eventName, eventParams) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: eventName,
        ...eventParams,
      });
    }
  }

  function initSearch() {
    const searchInput = document.getElementById('business-search');
    const businessList = document.getElementById('business-list');

    // Exit if elements don't exist (not on the main listing page)
    if (!searchInput || !businessList) {
      return;
    }

    const clearButton = document.getElementById('clear-search');
    const searchResult = document.getElementById('search-result');
    const searchResultList = searchResult.querySelector('ul');
    const resultsCount = document.getElementById('search-results-count');

    // on focus into input, scroll down to it
    searchInput.addEventListener('focus', function () {
      searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // Debounce timer for search tracking
    let searchTrackingTimer = null;

    // Search input event listener
    searchInput.addEventListener('input', function (e) {
      const query = e.target.value.trim();
      const outcome = performSearch(query);

      // Show/hide clear button
      if (query.length > 0) {
        clearButton.classList.remove('hidden');

        // Track search query with debouncing (wait 1 second after typing stops)
        clearTimeout(searchTrackingTimer);
        searchTrackingTimer = setTimeout(function () {
          // Only track if the query hasn't changed since the timeout was set
          // This prevents tracking stale queries if the user continues typing
          if (searchInput.value.trim() === query) {
            trackEvent('search_query', {
              search_term: query,
              search_length: query.length,
            });

            // Track search results displayed (including zero results)
            trackEvent('search_results_displayed', {
              search_term: query,
              results_count: outcome.length,
            });
          }
        }, 1000);
      } else {
        clearButton.classList.add('hidden');
        clearTimeout(searchTrackingTimer);
      }
    });

    // Clear button event listener
    clearButton.addEventListener('click', function () {
      searchInput.value = '';
      clearButton.classList.add('hidden');
      performSearch('');
      searchInput.focus();

      // Track clear action
      trackEvent('search_clear', {
        action: 'clear_button_click',
      });
    });

    // Allow clearing with Escape key
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchInput.value) {
        searchInput.value = '';
        clearButton.classList.add('hidden');
        performSearch('');

        // Track clear action via Escape key
        trackEvent('search_clear', {
          action: 'escape_key',
        });
      }
    });

    /**
     * Perform search and filter business list
     * @param {string} query - Search query
     * @returns {Array} Filtered results array. Returns all businesses for empty queries,
     *                  matching businesses for non-empty queries (may be empty if no matches)
     */
    function performSearch(query) {
      const normalizedQuery = query.toLowerCase();
      let visibleCount = 0;

      const outcome = consumersData.filter(function (item) {
        const businessName = item.name;
        const activities = item.activities;

        // Check if query matches business name or any activity
        const matchesName = businessName.toLowerCase().includes(normalizedQuery);
        const matchesActivity = activities.some((activity) => activity.toLowerCase().includes(normalizedQuery));

        if (query === '' || matchesName || matchesActivity) {
          visibleCount++;
        }
        return query === '' || matchesName || matchesActivity;
      });

      if (outcome.length > 0 && query !== '') {
        searchResultList.innerHTML = '';
        outcome.forEach(function (item) {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = item.path;
          a.classList.add('search-result-item');
          a.textContent = item.name;

          // Track click on search result
          a.addEventListener('click', function () {
            trackEvent('search_result_click', {
              business_name: item.name,
              business_path: item.path,
              search_term: query,
              result_position: outcome.indexOf(item) + 1,
            });
          });

          li.appendChild(a);
          searchResultList.appendChild(li);
          const div = document.createElement('div');
          div.classList.add('text-xs', 'mt-2', 'text-darkGray');
          div.innerHTML = item.activities.join(', ');
          a.appendChild(div);
        });

        searchResult.classList.remove('hidden');
      } else {
        searchResultList.innerHTML = '';
        searchResult.classList.add('hidden');
      }

      // Update results count
      updateResultsCount(visibleCount, consumersData.length);

      // Show "no results" message if needed
      showNoResultsMessage(visibleCount);

      return outcome;
    }

    /**
     * Update the results count display
     * @param {number} visible - Number of visible results
     * @param {number} total - Total number of businesses
     */
    function updateResultsCount(visible, total) {
      if (searchInput.value.trim() === '') {
        resultsCount.textContent = '';
      } else {
        const resultText = visible === 1 ? 'business' : 'businesses';
        resultsCount.textContent = `Showing ${visible} of ${total}+ ${resultText}`;
      }
    }

    /**
     * Show or hide "no results" message
     * @param {number} visibleCount - Number of visible results
     */
    function showNoResultsMessage(visibleCount) {
      const existingMessage = document.getElementById('no-results-message');

      if (visibleCount === 0 && searchInput.value.trim() !== '') {
        if (!existingMessage) {
          const message = document.createElement('div');
          message.id = 'no-results-message';
          message.className = 'p-8 text-center text-darkGray bg-lightGray rounded-lg';
          message.innerHTML = `
            <svg class="w-8 h-8 mx-auto mb-4 text-gray" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            <p class="text-lg font-semibold mb-2">No businesses found</p>
            <p class="text-sm">Try adjusting your search terms or <button type="button" class="text-blue underline hover:no-underline" onclick="document.getElementById('clear-search').click()">clear the search</button>.</p>
          `;
          businessList.parentNode.insertBefore(message, businessList);
        }
      } else if (existingMessage) {
        existingMessage.remove();
      }
    }
  }
})();
